export default {
    async isAvailableAsync() {
        return false;
    },
    startObserving() { },
    stopObserving() { },
};
//# sourceMappingURL=ExpoBarometer.web.js.map